import { SchemaWithClient } from '../types/SchemaWithClient';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { Client } from '../services/Client';
import { DateTimeField } from '../components/Table/fields/DateTimeField';
import { SPDateTimeField } from '../components/Table/fields/SPDateTimeField';

export const crazyBooking: SchemaWithClient<any> = {
  name: 'Crazy Booking',
  pluralName: 'Crazy Bookings',
  showDeleted: true,
  hasSum: true,
  columns: {
    service_name: {
      name: 'Service Name',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    checking_state: {
      name: 'Checking State',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    booking_state: {
      name: 'Booking State',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    day: {
      name: 'Day',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    order: {
      name: 'Order',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    slot: {
      name: 'Slot',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    start_time: {
      name: 'Start Time',
      readOnly: true,
      fieldRenderer: DateTimeField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'dateTime',
    },
    start_time_text: {
      name: 'Start Time Text',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    participants_count: {
      name: 'Participants Count',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    guide_name: {
      name: 'Guide Name',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    start_address: {
      name: 'Start Address',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    price: {
      name: 'Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    provider_price: {
      name: 'Provider Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    total_price: {
      name: 'Total Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    currency: {
      name: 'Currency',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    created_at: {
      name: 'Created At',
      readOnly: true,
      fieldRenderer: DateTimeField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'dateTime',
    },
    updated_at: {
      name: 'Updated At',
      readOnly: true,
      fieldRenderer: DateTimeField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'dateTime',
    },
    payment_state: {
      name: 'Payment State',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    nature: {
      name: 'Nature',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    nights_count: {
      name: 'Nights Count',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    conditions: {
      name: 'Conditions',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    file: {
      name: 'File',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    need_file: {
      name: 'Need File',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    buying_mode: {
      name: 'Buying Mode',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    is_send_confirmation: {
      name: 'Send Condirmation',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    available_state: {
      name: 'Available State',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    comment_available_state: {
      name: 'Comment Available State',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    proposed_prestation_id: {
      name: 'Proposed Preseation ID',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    provided_prestation_id: {
      name: 'Provided Prestation ID',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    roadmap_text: {
      name: 'Roadmap Text',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    hotline_number: {
      name: 'Hotline Number',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    provider_name: {
      name: 'Provider Name',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    group_id: {
      name: 'Group ID',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    id: {
      name: 'ID',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/crazy-bookings'),
  viewTable: 'crazy-bookings',
  isViewTable: true,
};
